import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';

const WeChatQRDialog = ({ open, onClose, title = "微信扫码咨询" }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <img
          src="/wechat-qr.jpg"
          alt="微信二维码"
          style={{ width: 240, height: 240, objectFit: 'contain' }}
        />
        <div style={{ marginTop: 16, fontSize: '1rem', fontWeight: 500 }}>
          {title}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WeChatQRDialog; 